var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterGreyIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_252_1",
    "data-name": "Component 252 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "filter_alt_24dp_000000_FILL0_wght100_GRAD0_opsz24",
    d: "M246.5-728.266a1,1,0,0,1-.736-.294,1,1,0,0,1-.295-.736v-8.026l-7.768-9.793a.5.5,0,0,1-.055-.589.536.536,0,0,1,.5-.295h16.715a.536.536,0,0,1,.5.295.5.5,0,0,1-.055.589l-7.768,9.793v8.026a1,1,0,0,1-.295.736A1,1,0,0,1,246.5-728.266Zm0-9.425,7.29-9.278H239.207ZM246.5-737.691Z",
    transform: "translate(-230.571 754)",
    fill: "#707070"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7708",
    "data-name": "Rectangle 7708",
    width: 32,
    height: 32,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterGreyIcon);
export default __webpack_public_path__ + "static/media/FilterGreyIcon.64dd86988aec9888ae277545119170dd.svg";
export { ForwardRef as ReactComponent };